import { clinicBuilding } from "../../assets/components/svgs";
import sideBarPaths from "../../constants/side-menu.constants";
import { IUserFeatures } from "./models/Menu";
import { useAppSelector } from "../../app/hooks";
import {
  SideButton,
  SideGroupButton,
  LinkContainer,
  StyledSidebar,
  SideButtonTitle,
  AccordionItem,
  SideGroupSubButton,
  SideGroupButtonTitle,
  VersionDiv,
  AccordionUl,
} from "./MenuStyles";
import { useState } from "react";
import { SideBarItemConfig } from "../../app/models/menu/sideBar";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTheme } from "../../context/themeContext";
import env from "../../environment";
import { dropdown } from "../../assets/components/svgs";
import { RouteConstants } from "../../constants/RouteConstants";
import { getUserRoles } from "../../util/admin-utils";
import { AppConstants } from "../../constants/AppConstants";
import { useCheckMobileScreen } from "../../util/customHooks";
import { useTranslation } from "react-i18next";
import { capitalize } from "lodash";

type Props = {
  sidebarIsActive: boolean;
  modalIsActive?: boolean;
  setSidebarIsActive: Function;
};

export const appRoutes: any = {
  key1: ["patient-request", RouteConstants.ROUTE_GDPR_LIST],
  key2: ["patient-request", RouteConstants.ROUTE_GDPR_CREATE],
};

export const getSideBarConfigFromKey = (
  key: string,
  sideBarPath: any
): SideBarItemConfig => {
  const [sideItem] = sideBarPath.filter(
    (item: SideBarItemConfig) => item.key === key
  );
  return sideItem || null;
};

const Sidebar = ({ sidebarIsActive, setSidebarIsActive }: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [selectedItem, setSelectedItem] = useState(0);
  let loaded = false;

  const userProfile = useAppSelector(
    (state) => state.userManagement.userProfileInfo
  );

  const isMobileScreen = useCheckMobileScreen();

  const getGroupItems = () => {
    const roleName = getUserRoles(userProfile)
      .map((role: any) => role.name)
      .join();

    let GroupItems = [
      {
        name: t("T_PATIENT_REQUESTS"),
        menu: [
          {
            key: "key1",
            name: "Create Request",
            label: t("T_CREATE_REQUEST"),
            active: true,
            groupName: t("T_PATIENT_REQUESTS"),
            description: "This feature allows you to Create GDPR Request",
            groupSequence: "1",
          },
          {
            key: "key2",
            name: "Request History",
            label: t("T_REQUEST_HISTORY"),
            active: true,
            groupName: t("T_PATIENT_REQUESTS"),
            description:
              "This feature allows you to view Request History for GDPR",
            groupSequence: "1",
          },
        ],
        key: "1",
        groupSequence: "1",
      },
    ];

    if (
      AppConstants.ENABLED_ROLES_CUSTOMIZATION.includes(roleName) &&
      !isMobileScreen
    ) {
      GroupItems.push({
        name: t("T_SETTINGS"),
        menu: [
          {
            key: "key3",
            name: "Customization",
            label: t("T_CUSTOMIZATION"),
            active: true,
            groupName: t("T_SETTINGS"),
            description: "This feature allows you configure branding",
            groupSequence: "1",
          },
        ],
        key: "2",
        groupSequence: "2",
      });
    }
    return GroupItems;
  };

  const changeItemSelected = (i: number) => {
    setSelectedItem(i);
    loaded = !loaded;
  };

  const navigateToItem = async (item: any) => {
    const { path } = item;
    navigate(item?.path);
    if (isMobileScreen) setSidebarIsActive(false);
  };

  const isGroupSelected = (item: any) => {
    var itemKey: any = item.map((ele: any) => {
      return appRoutes[ele.key];
    });

    return itemKey.flat(1).includes(location.pathname.split("/")[1]);
  };

  return (
    <StyledSidebar isActive={sidebarIsActive} theme={useTheme().theme}>
      <LinkContainer
        isActive={sidebarIsActive}
        className="scrollbar-track-{transparent} scrollbar-thin scrollbar-thumb-rounded scrollbar-track-rounded-full scrollbar-thumb-stone-300"
        id="sideNavParent"
      >
        {getGroupItems()?.map((menuData: any, menuIndexN: number) => (
          <AccordionItem key={`accordion-${menuData.name}`}>
            {menuData.groupSequence ? (
              // Group button
              <>
                <SideGroupButton
                  className="accordion-button focus:outline-none"
                  data-active-classes="text-red-600"
                  data-mdb-ripple="true"
                  data-mdb-ripple-color="dark"
                  data-bs-toggle="collapse"
                  data-bs-target={"#collapseSidenavEx" + menuIndexN}
                  aria-expanded="false"
                  aria-controls={"collapseSidenavEx" + menuIndexN}
                  role="sidebutton"
                  isActive={sidebarIsActive}
                  key={
                    getSideBarConfigFromKey(menuData.name, sideBarPaths)?.key
                  }
                  isSelected={isGroupSelected(menuData.menu)}
                  title={menuData.name}
                  theme={useTheme().theme}
                >
                  <div className="h-6 w-6">
                    {getSideBarConfigFromKey(menuData.name, sideBarPaths)
                      ?.icon || clinicBuilding}
                  </div>
                  <SideButtonTitle isActive={sidebarIsActive}>
                    {menuData.label ? menuData.label : menuData.name}
                  </SideButtonTitle>
                  <div
                    className="ml-auto w-fit"
                    style={{ display: sidebarIsActive ? "block" : "none" }}
                  >
                    {dropdown}
                  </div>
                </SideGroupButton>

                <AccordionUl
                  // className="collapse"
                  id={"collapseSidenavEx" + menuIndexN}
                  // aria-labelledby={'sidenavEx' + menuIndexN}
                  data-bs-parent={"#sideNavParent"}
                >
                  {menuData.menu?.map((menu: any, menuIndex: number) => (
                    <li key={menu.name} className="relative">
                      <SideGroupSubButton
                        role="sidebutton"
                        isActive={sidebarIsActive}
                        isSelected={appRoutes[menu.key]?.includes(
                          location.pathname.split("/")[1]
                        )}
                        onClick={() => {
                          changeItemSelected(menuIndex);
                          getSideBarConfigFromKey(menu.name, sideBarPaths) &&
                            navigateToItem(
                              getSideBarConfigFromKey(menu.name, sideBarPaths)
                            );
                        }}
                        key={
                          getSideBarConfigFromKey(menu.name, sideBarPaths)?.key
                        }
                        title={menu.name}
                        theme={useTheme().theme}
                      >
                        <div
                          className="h-5 w-5"
                          style={{
                            visibility: sidebarIsActive ? "hidden" : "visible",
                          }}
                        >
                          {getSideBarConfigFromKey(menu.name, sideBarPaths)
                            ?.icon || clinicBuilding}
                        </div>
                        <SideGroupButtonTitle isActive={sidebarIsActive}>
                          {menu.label ? menu.label : menu.name}
                        </SideGroupButtonTitle>
                      </SideGroupSubButton>
                    </li>
                  ))}
                </AccordionUl>
              </>
            ) : (
              // Single button
              <SideButton
                role="sidebutton"
                isActive={sidebarIsActive}
                isSelected={isGroupSelected(menuData.menu)}
                onClick={() => {
                  changeItemSelected(menuIndexN);
                  getSideBarConfigFromKey(menuData.name, sideBarPaths) &&
                    navigateToItem(
                      getSideBarConfigFromKey(menuData.name, sideBarPaths)
                    );
                }}
                key={getSideBarConfigFromKey(menuData.name, sideBarPaths)?.key}
                title={menuData.name}
                theme={useTheme().theme}
              >
                <div className="h-6 w-6">
                  {getSideBarConfigFromKey(menuData.name, sideBarPaths)?.icon ||
                    clinicBuilding}
                </div>
                <SideButtonTitle isActive={sidebarIsActive}>
                  {menuData.menu[0].label || menuData.menu[0].name}
                </SideButtonTitle>
              </SideButton>
            )}
          </AccordionItem>
        ))}
      </LinkContainer>

      <VersionDiv isActive={sidebarIsActive}> {env.version}</VersionDiv>
    </StyledSidebar>
  );
};

export default Sidebar;
